import CarotekColors from "@carotek/utils/Colors";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    ...cardContainerMultiColumnStyles,
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            padding: 10px 0;
            border: 0.5px solid ${CarotekColors.grey12};
            border-top: 0;

            :nth-child(3n + 2) {
                border-left: 0;
                border-right: 0;
            }

            :last-child {
                border-right: 0.5px solid ${CarotekColors.grey12};
            }
        `,
    },
    cardDivider: {
        css: css`
            padding: 15px;
            height: 100%;
            width: 100%;
            overflow: hidden;
        `,
    },
});
